// client/src/pages/ShippingPage.js
import React, { useState, useRef } from "react";
import { getRates, createLabel } from "../api/shippingApi";
import ShipmentForm from "../components/ShipmentForm";
export default function ShippingPage() {
  const formRef = useRef();

  const [, setLabelData] = useState(null);
  const [, loadingRates] = useState(false);
  const [loadingLabel, setLoadingLabel] = useState(false);
  const [, setShipmentData] = useState(null);

  const handleFormSubmit = async (data) => {
    setShipmentData(data);
    setLoadingLabel(true);

    try {
      const returnedRates = await getRates({
        ...data,
        toAddress: {
          name: "Photolounge",
          street1: "130 S 17th St",
          city: "Philadelphia",
          state: "PA",
          zip: "19103",
          country: "US",
        },
      });
      console.log(":white_check_mark: All returned rates:", returnedRates);
      const groundUSPSRate = returnedRates
        .filter((rate) => {
          const provider = rate.provider?.toLowerCase() || "";
          const token = rate.servicelevel?.token?.toLowerCase() || "";
          const name = rate.servicelevel?.name?.toLowerCase() || "";

          return (
            provider === "usps" &&
            (token === "usps_ground_advantage" ||
              token === "ground" ||
              name.includes("ground advantage") ||
              name.includes("ground"))
          );
        })
        .sort((a, b) => parseFloat(a.amount) - parseFloat(b.amount))[0];
      console.log(":package: Filtered USPS Ground rate:", groundUSPSRate);
      if (!groundUSPSRate) {
        console.warn(":warning: No USPS Ground rate found.");
        alert("No USPS Ground rate found.");
        return;
      }
      const { labelUrl, trackingNumber } = await createLabel(
        groundUSPSRate.objectId,
      );
      setLabelData({ labelUrl, trackingNumber });
      console.log(":white_check_mark: Label created:", {
        labelUrl,
        trackingNumber,
      });
      const newWindow = window.open(labelUrl, "_blank");
      if (
        !newWindow ||
        newWindow.closed ||
        typeof newWindow.closed === "undefined"
      ) {
        alert(
          "Your shipping label was created, but your browser blocked the pop-up window.\n\nPlease allow pop-ups and check your browser’s toolbar or settings.",
        );
      }
      // :stopwatch: Delay hiding the loading modal so user can read it
      setTimeout(() => {
        setLoadingLabel(false);
      }, 3000);
    } catch (err) {
      console.error(":x: Error creating and downloading label", err);
      alert("Failed to create label.");
      setLoadingLabel(false);
    }
  };

  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: 20 }}>
      {/* Full-screen white modal during label processing */}
      {loadingLabel && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "#FFFFFF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              textAlign: "center",
              fontSize: "18px",
              color: "#111",
              padding: "24px",
              maxWidth: "500px",
            }}
          >
            <p
              style={{
                fontWeight: "bold",
                fontSize: "20px",
                marginBottom: "16px",
              }}
            >
              Creating Your Shipping Label…
            </p>
            <p>Please wait.</p>
            <p style={{ marginTop: "12px", color: "#c00", fontWeight: "500" }}>
              Make sure pop-up windows are not blocked in your browser.
            </p>
          </div>
        </div>
      )}
      {/* Centered Logo */}
      <div style={{ textAlign: "center", marginBottom: 50, paddingTop: 50 }}>
        <img
          src="/PL_Logo.png"
          alt="Photolounge Logo"
          style={{ maxWidth: 300 }}
        />
      </div>
      <h1>Create Shipping Label</h1>
      {/* STEP 1: Shipment Form */}
      <ShipmentForm
        ref={formRef}
        onSubmit={handleFormSubmit}
        loading={loadingRates}
      />
      {/* STEP 3: Label Download Link */}
      <button
        onClick={() => {
          if (!loadingLabel) {
            formRef.current?.triggerSubmit();
          }
        }}
        disabled={loadingLabel}
        style={{
          marginTop: 12,
          padding: "8px 16px",
          fontSize: 16,
          backgroundColor: loadingLabel ? "#bbb" : "#ED174F",
          color: "white",
          border: "none",
          borderRadius: 10,
          cursor: loadingLabel ? "not-allowed" : "pointer",
        }}
      >
        {loadingLabel ? "Creating Label… Please Wait" : "Print Label"}
      </button>
    </div>
  );
}
